export const fetchPermissionsFiltersUrl = `/profile/permissions/list/filters`;
export const fetchPermissionsUpdateUrl = `/profile/permissions`;
export const fetchPermissionsListUrl = `/profile/permissions`;
